import { render, staticRenderFns } from "./OrderDescription.vue?vue&type=template&id=2da10336"
import script from "./OrderDescription.vue?vue&type=script&lang=js"
export * from "./OrderDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports